export function bodyClassGuard(to) {
  document.body.className = "";

  const record = [...to.matched].reverse().find((r) => r.meta?.bodyClass);
  if (!record) return;

  const { section, bodyClass } = record.meta;
  document.body.classList.add(section ? `${section}-${bodyClass}` : bodyClass);
}
